<template>
    <el-dialog width="520px" :title="groupingId ? '编辑分组' : '添加分组'" :before-close="handleClickCancel" :close-on-press-escape="false"
               :close-on-click-modal="false" :visible.sync="groupingVisible" append-to-body>
        <div class="details">
            <el-form size="small" ref="generalForm"   v-loading="loading"
                     label-position="top" :model="generalForm"  :rules="generalFormRules">
                <el-form-item label="分组名称" prop="name">
                    <el-input v-model="generalForm.name"  placeholder="请填写分组名称" maxlength="30" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="上级分组" prop="pid">


                    <el-popover v-if="(groupingId == 0 && groupingPid == 0) || (groupingId != 0 && groupingPid == 0)" placement="bottom" trigger="click" v-model="popoverShow" width="472">
                        <el-select :popper-append-to-body="false" class="selectTree" placeholder="请选择上级分组" readonly slot="reference"  v-model="generalForm.parent_name"></el-select>
                        <div class="tree_wrap" >
                            <el-tree :check-on-click-node="true"
                                     :check-strictly="true"
                                     :data="categoryDataList"
                                     :default-expand-all="true"
                                     :expand-on-click-node='false'
                                     :props="{children: 'children',label: 'name'}"
                                     @node-click="handleSelectNode"
                                     node-key="id"
                                     ref="selectTree"
                                     size="mini">
                            </el-tree>
                        </div>
                    </el-popover>
                    <el-input v-else v-model="generalForm.parent_name"  disabled placeholder="" ></el-input>

                </el-form-item>

            </el-form>
        </div>
        <div slot="footer">
            <el-button size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
            <el-button size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import {GoodsCategoryAdd,GoodsCategoryList,GoodsCategoryDetail,GoodsCategoryEdit} from '@/api'
import {mapState} from "vuex";
export default {
    name: 'categoryTemplate',
    props: {
        groupingVisible: {
            type: Boolean,
            default: false,
        },
        groupingId: {
            type: Number,
            default: 0,
        },
        groupingPid: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            loading:false,
            BtnDisabled: false,
            generalForm:{
                name:'',
                parent_name:'无上级分组',
                pid:0,
            },
            generalFormRules:{
                name:[{ required: true, message: '请填写名称', trigger: 'blue'}],
            },
            categoryDataList:[],
            popoverShow:false
        }
    },
    created() {
        this.getCategoryData()
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        getCateGoryDetail() {
            GoodsCategoryDetail({id:this.groupingId}).then(res => {
                if (res.code === 200) {
                    this.generalForm.name = res.data.name
                    this.generalForm.pid = res.data.pid
                    this.generalForm.parent_name = res.data?.parent?.name || '无上级分组'
                }
                this.loading = false
            })

        },

        getCategoryData(){
            this.loading = true
            GoodsCategoryList({}).then(res => {
                if (res.code === 200) {
                    this.categoryDataList = this.filterByLevel(res.data,2)
                    this.categoryDataList.unshift({id:0,name:'无上级分组',path:[]})
                    console.log(this.categoryDataList);
                }
                if(this.groupingPid){ //查找父节点
                   let info = this.findById(this.categoryDataList, this.groupingPid)
                   this.generalForm.pid = this.groupingPid
                   this.generalForm.parent_name = info?.name
                }
                if(this.groupingId){
                    this.getCateGoryDetail()
                }else{
                    this.loading = false
                }

            })
        },
        // 去除节点
        filterByLevel(nodes, maxLevel) {
            return nodes.filter(node => {
                node.path_arr = node.path ? node.path.split('/') : []
                if (node.level > maxLevel) return false;
                // 递归处理子节点
                if (node.children && node.children.length) {
                    node.children = this.filterByLevel(node.children, maxLevel);
                }
                return true;
            });
        },
        findById(data, id) {
            for (const item of data) {
                if (item.id === id) {
                    return item;
                }
                if (item.children) {
                    const found = this.findById(item.children, id);
                    if (found) {
                        return found;
                    }
                }
            }
            return null;
        },

        handleSelectNode(data, node, nodeData){
            if(data.level == 3){return this.$message.error('最多只可以添加三级')}
            if(this.groupingId ==  data.id || data.path.indexOf(this.groupingId) > -1){
                return this.$message.error('不能选择自己和自己的子集')
            }

            let levelNum1 = this.getTreeDepth(this.findById(this.categoryDataList, this.groupingId)) + 1 //被编辑的节点

            if(levelNum1 + data.level > 3){
                return this.$message.error('最多只可以添加三级')
            }
            this.generalForm.pid = data.id;
            this.generalForm.parent_name = data.name;
            this.popoverShow = false
        },

        // 获取一共有几级结构
        getTreeDepth(node) {
            if (!node.children || !Array.isArray(node.children) || node.children.length === 0) {
                return 1;
            }
            const childrenDepths = node.children.map(child => this.getTreeDepth(child));
            return 1 + Math.max(...childrenDepths);
        },


        handleClickConfirm(){
            this.$refs.generalForm.validate(valid => {
                if (valid) {
                    this.BtnDisabled = true
                    if(this.groupingId){
                        GoodsCategoryEdit({
                            id:this.groupingId,
                            name:this.generalForm.name.trim(),
                            pid:this.generalForm.pid,
                        }).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    message: '编辑成功',
                                    type: 'success',
                                    duration: 1000,
                                    onClose: () => {
                                        this.BtnDisabled = false
                                        this.$emit('success')
                                        this.$emit('update:groupingVisible', false)
                                    }
                                })

                            }
                        })
                    }else{
                        GoodsCategoryAdd({
                            name:this.generalForm.name.trim(),
                            pid:this.generalForm.pid,
                        }).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    message: '新增成功',
                                    type: 'success',
                                    duration: 1000,
                                    onClose: () => {
                                        this.BtnDisabled = false
                                        this.$emit('success')
                                        this.$emit('update:groupingVisible', false)
                                    }
                                })

                            }
                        })
                    }
                }
            })
        },


        //取消事件
        handleClickCancel() {
            //关闭对话框
            this.$emit('update:groupingVisible', false)
        },


    },

}
</script>
<style lang="scss" scoped>
    .selectTree{
        width: 100%;
        ::v-deep .el-select-dropdown{
            display: none !important;
        }
    }
</style>
